module.exports = __webpack_public_path__ + "static/media/Coin.cd0bc0f0.png";